module.exports = __webpack_public_path__ + "static/media/Exo-Regular.708689f5.ttf";